import React, { useEffect, useState } from "react";
import { useAppDispatch, useAppSelector } from "../../hooks/redux";
import { addTaskToQueue, getBaseContent, searchBaseContent, getBaseContentCatgories } from "../../actions/videoInput";
import { selectBaseContent, selectBaseContentCount,selectBaseContenCategories } from "../../actions/selectors";
import { Button, Dropdown, Pagination, Table } from "semantic-ui-react";
import SearchField from "../../components/admin/SearchField";
export default function BasecontentPage() {
  const dispatch = useAppDispatch();
  const basecontent = useAppSelector(selectBaseContent);
  const basecontentCount = useAppSelector(selectBaseContentCount) || 1
  const basecontentCategories = useAppSelector(selectBaseContenCategories) || []
  const [currentPage, set_currentPage] = useState(1);
  const [itemsPerPage] = useState(100);
  const [searchTerms, set_searchTerms] = useState<undefined| string>(undefined)

  useEffect(() => {
    const offset = currentPage !== 1 ? (currentPage ) * itemsPerPage : 0
    dispatch(getBaseContent({limit: itemsPerPage, offset}));
    dispatch(getBaseContentCatgories());
  }, [itemsPerPage,currentPage]);

  const addToQueue = (baseContentId: number) => {
    dispatch(addTaskToQueue(baseContentId))
  }
  const handlePageChange = (_:any, {activePage}:any) => {
    set_currentPage(activePage)
  }
  const handleTyping = (s:string)=> {
    set_searchTerms(s)
  }
  const handleSearch = () => {
    dispatch(searchBaseContent({limit: itemsPerPage, offset: 0, search: searchTerms || ""}));
  }
  const handleDropdown = (e:any, {value}:any) => {
    dispatch(searchBaseContent({limit: itemsPerPage, offset: 0, search: searchTerms || "", category: value}));
  }

  const stateOptions = ["", ...basecontentCategories]?.map( (category, index) => ({
    key: index,
    text: category,
    value: `${category}`,
  }))

  return (
    <div>
      <h1>Base Content available </h1>
        <p><em>Base content is wat we op de locale server hebben staan</em></p>
        <p><em>Als je op de link kan klikken is dit item beschikbaar voor onze klanten</em></p>
        <br/>
        <p>todolist:</p>
        <ul>
          <li>we moeten even fixen dat je kan zien dat een item in de queue staat, maar dat is kut zoeken in de tabel omdat het json is</li>
          <li>filteren op folder/categorie toevoegen</li>
          </ul>
          <SearchField searchText={searchTerms} handleTyping={handleTyping} handleSearch={handleSearch} />
          <h3>filter op categorie</h3>
          <Dropdown placeholder='State' search selection options={stateOptions} onChange={handleDropdown} />
      <Table celled>
        <Table.Header>
          <Table.Row>
              <Table.HeaderCell>id</Table.HeaderCell>
              <Table.HeaderCell>filename</Table.HeaderCell>
              <Table.HeaderCell>folder/category</Table.HeaderCell>
              <Table.HeaderCell>video's available</Table.HeaderCell>
              <Table.HeaderCell>constructionVideoId</Table.HeaderCell>
              <Table.HeaderCell>link</Table.HeaderCell>
          </Table.Row>
        </Table.Header>

        <Table.Body>
          {basecontent?.map((content, i) => {
            return (
              <Table.Row key={i}>
                <Table.Cell>{content?.id}</Table.Cell>
                <Table.Cell>{content?.sourceFilename}</Table.Cell>
                <Table.Cell>{content?.sourceCategory}</Table.Cell>
                <Table.Cell>{content?.constructionVideoMeta?.length}</Table.Cell>
                { content?.constructionVideoMeta?.length === 0 ? <Table.Cell><Button onClick={() => addToQueue(content?.id)}>add to queue</Button></Table.Cell> :  
                <Table.Cell>{content?.constructionVideoMeta?.[0]?.constructionVideoId}</Table.Cell>
                }
                {content?.constructionVideoMeta?.[0]?.constructionVideoId ?
                <Table.Cell> <a href={`/libaryInfo/${content?.constructionVideoMeta?.[0]?.constructionVideoId}/video`}>constructionVideoId</a></Table.Cell>
                : <Table.Cell></Table.Cell>}
              </Table.Row>
            );
          })}
        </Table.Body>
      </Table>
        <Pagination defaultActivePage={currentPage} totalPages={Math.ceil(basecontentCount/itemsPerPage)} onPageChange={handlePageChange} />
    </div>
  );
}
